import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SliderService from "../../services/SliderService";

const Slider = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialSliderState = {
    id: null,
    name: "",
    label: "",
    image: null,
    alt: "",
    published: false,
  };
  const [currentSlider, setCurrentSlider] = useState(initialSliderState);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const getSlider = (id) => {
    SliderService.get(id)
      .then((response) => {
        setCurrentSlider(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getSlider(id);
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentSlider({ ...currentSlider, [name]: value });
  };

  const handleImageInputChange = (e) => {
    const { name, value } = e.target;
    const inputimage = e.target.files[0];
    setCurrentSlider({ ...currentSlider, [name]: inputimage });
  };

  const updateSlider = () => {
    SliderService.update(currentSlider.id, currentSlider)
      .then((response) => {
        // console.log(response)
        setMessage("The Slider was updated successfully!");
        setSubmitted(true);
      })
      .catch((e) => {
        setMessage("Error: " + e.response.data.message);
        setSubmitted(true);
      });
  };

  const deleteSlider = () => {
    SliderService.remove(currentSlider.id)
      .then((response) => {
        console.log(response.data);
        navigate("/admin/slider");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div className="container pb-10">
      {currentSlider ? (
        <>
          <h1 className="text-1xl lg:text-1xl font-semibold py-10">
            {" "}
            Edit {currentSlider.name}
          </h1>
          <div>
            {submitted ? (
              <div
                className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                role="alert"
              >
                <p style={{ marginBottom: "0" }}>{message}</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: "0" }}>{message}</p>
              </>
            )}
            <br></br>
          </div>

          <form className="w-full">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Name
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="name"
                  name="name"
                  type="text"
                  value={currentSlider.name}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Description
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="label"
                  name="label"
                  type="text"
                  value={currentSlider.label}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                  Image
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  type="file"
                  id="image"
                  onChange={handleImageInputChange}
                  name="image"
                />
              </div>
            </div>
          </form>

          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 grid grid-cols-2 gap-40">
              <button
                className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                onClick={deleteSlider}
              >
                Delete
              </button>

              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={updateSlider}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <br />
          <p>Please click on a Social...</p>
        </div>
      )}
    </div>
  );
};

export default Slider;
